import { render, staticRenderFns } from "./PageMiniGamesScore.vue?vue&type=template&id=5ea73bd3&scoped=true&"
import script from "./PageMiniGamesScore.vue?vue&type=script&lang=js&"
export * from "./PageMiniGamesScore.vue?vue&type=script&lang=js&"
import style0 from "./PageMiniGamesScore.vue?vue&type=style&index=0&id=5ea73bd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea73bd3",
  null
  
)

export default component.exports